import React, { useState } from 'react';
import './AntiRaggingStyles.css';
import Navbar from "../components/navbar";
import Footer from "../components/Footer";
import "../about/SplashPdfViewer.css";
import CTAButton from "../components/sticky-button";
import PageHeader from "../about/PageHeader";

// --- Refined SVGs Matching the Design ---

const RedShieldAlert = () => (
  <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="28" cy="28" r="28" fill="#fecaca" opacity="0.4" />
    <circle cx="28" cy="28" r="18" fill="#ef4444" />
    <path d="M28 17l-6 2.5v5.5c0 3.8 2.5 7.4 6 8.5 3.5-1.1 6-4.7 6-8.5v-5.5L28 17z" fill="#fff" />
    <circle cx="28" cy="23" r="2" fill="#ef4444" />
    <path d="M27 25h2v3h-2z" fill="#ef4444" />
  </svg>
);

const BlueDocIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke="#4f46e5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M14 2v6h6M16 13H8M16 17H8M10 9H8" stroke="#4f46e5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const RefinedPdfIcon = () => (
  <svg width="60" height="60" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 4h14l10 10v20a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z" fill="#fff" stroke="#cbd5e1" strokeWidth="1.5" />
    <path d="M24 4v10h10" fill="#f8fafc" stroke="#cbd5e1" strokeWidth="1.5" strokeLinejoin="round" />
    <rect x="7" y="20" width="26" height="12" rx="2" fill="#ef4444" />
    <text x="11" y="29" fill="#fff" fontSize="9" fontWeight="800" fontFamily="sans-serif" letterSpacing="1.5">PDF</text>
  </svg>
);

const ActIconWrapper = ({ children }) => (
  <svg width="56" height="56" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="24" cy="24" r="24" fill="#eef2ff" />
    <g stroke="#4f46e5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" transform="translate(12, 12)">
      {children}
    </g>
  </svg>
);

const SectionHeaderIcon = ({ style }) => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
    <rect width="48" height="48" rx="12" fill="#eef2ff" />
    <circle cx="16" cy="19" r="3.5" fill="#4f46e5" />
    <path d="M10 29v-1.5c0-2.5 2-4.5 4.5-4.5h3v6h-7.5z" fill="#4f46e5" />
    <circle cx="32" cy="19" r="3.5" fill="#4f46e5" />
    <path d="M38 29v-1.5c0-2.5-2-4.5-4.5-4.5h-3v6h7.5z" fill="#4f46e5" />
    <circle cx="24" cy="17" r="5.5" fill="#eef2ff" />
    <path d="M17 29v-2c0-3.3 2.7-6 6-6h2c3.3 0 6 2.7 6 6v2H17z" fill="#eef2ff" stroke="#eef2ff" strokeWidth="2" />
    <circle cx="24" cy="17" r="4" fill="#4f46e5" />
    <path d="M18 29v-2c0-2.8 2.2-5 5-5h2c2.8 0 5 2.2 5 5v2H18z" fill="#4f46e5" />
    <path d="M34 20l-6-2.5-6 2.5v5.5c0 3.8 2.5 7.4 6 8.5 3.5-1.1 6-4.7 6-8.5V20z" fill="#eef2ff" stroke="#eef2ff" strokeWidth="3" strokeLinejoin="round" />
    <path d="M34 20l-6-2.5-6 2.5v5.5c0 3.8 2.5 7.4 6 8.5 3.5-1.1 6-4.7 6-8.5V20z" fill="#4f46e5" />
    <path d="M25 25.5l2 2 4-4.5" stroke="#eef2ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const CardGroupIcon = ({ style }) => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
    <rect width="48" height="48" rx="12" fill="#eef2ff" />
    <circle cx="16" cy="20" r="3.5" fill="#4f46e5" />
    <path d="M10 30v-1.5c0-2.5 2-4.5 4.5-4.5h3v6h-7.5z" fill="#4f46e5" />
    <circle cx="32" cy="20" r="3.5" fill="#4f46e5" />
    <path d="M38 30v-1.5c0-2.5-2-4.5-4.5-4.5h-3v6h7.5z" fill="#4f46e5" />
    <circle cx="24" cy="18" r="5.5" fill="#eef2ff" />
    <path d="M17 30v-2c0-3.3 2.7-6 6-6h2c3.3 0 6 2.7 6 6v2H17z" fill="#eef2ff" stroke="#eef2ff" strokeWidth="2" />
    <circle cx="24" cy="18" r="4" fill="#4f46e5" />
    <path d="M18 30v-2c0-2.8 2.2-5 5-5h2c2.8 0 5 2.2 5 5v2H18z" fill="#4f46e5" />
  </svg>
);

// --- New Exactly Matched Info Cards Icons (with darker bgs) ---

const RefinedInfoIcon = () => (
  <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="26" cy="26" r="26" fill="#e0e7ff" /> {/* Distinct light blue background */}
    <circle cx="26" cy="26" r="14" stroke="#4f46e5" strokeWidth="2.5" />
    <circle cx="26" cy="20.5" r="1.5" fill="#4f46e5" />
    <path d="M26 24.5v7" stroke="#4f46e5" strokeWidth="2.5" strokeLinecap="round" />
  </svg>
);

const RefinedPhoneIcon = () => (
  <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="26" cy="26" r="26" fill="#d1fae5" /> {/* Distinct mint green background */}
    <g transform="translate(10.4, 10.4) scale(1.3)" fill="#10b981">
      <path d="M20 15.5c-1.2 0-2.4-.2-3.6-.6-.3-.1-.7 0-1 .2l-2.2 2.2c-2.8-1.4-5.1-3.8-6.6-6.6l2.2-2.2c.3-.3.4-.7.2-1-.4-1.2-.6-2.4-.6-3.6 0-.6-.5-1-1-1H4c-.6 0-1 .5-1 1 0 9.4 7.6 17 17 17 .6 0 1-.5 1-1v-3.5c0-.6-.5-1-1-1zM19 12h2a9 9 0 0 0-9-9v2c3.9 0 7.1 3.2 7.1 7.1zM15 12h2c0-2.2-1.8-4-4-4v2c1.1 0 2 .9 2 2z" />
    </g>
  </svg>
);

const RefinedShieldIcon = () => (
  <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="26" cy="26" r="26" fill="#fef08a" /> {/* Distinct light yellow background */}
    <path d="M26 12L15 16v7c0 6.5 4.5 12.5 11 15 6.5-2.5 11-8.5 11-15v-7l-11-4z" fill="#f59e0b" />
    <path d="M28.5 18.5l-2-2-1 1-.5 2.5-2.5 2.5-2-1-1 1 2.5 2.5-2.5 2.5 1.5 1.5 2.5-2.5 2.5 2.5 1-1-1-2 2.5-2.5 2.5-.5 1-1-2-2z" fill="#ffffff" />
  </svg>
);

const CircleTick = ({ color }) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="10" fill={color} />
    <path d="M8 12.5L10.5 15L16 9" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const BannerShieldIcon = () => (
  <svg width="64" height="64" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="24" cy="24" r="24" fill="#ffffff" opacity="0.2" />
    <path d="M24 10l-9 4v7.5c0 5.2 3.7 10 9 11.5 5.3-1.5 9-6.3 9-11.5V14l-9-4z" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M19 23l3 3 6-6" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const EyeIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>;
const DownloadIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>;

const AntiRagging = () => {
  // --- ADDED STATE FOR ACCORDIONS ---
  const [openAccordion, setOpenAccordion] = useState(null);

  const toggleAccordion = (index) => {
    // If clicking the one that is already open, close it. Otherwise, open the clicked one.
    setOpenAccordion(openAccordion === index ? null : index);
  };

  return (
    <>
      <Navbar />
      <CTAButton />
      <PageHeader
        title="Anti Ragging"
        crumbs={[{ label: 'Home', href: '/' }, { label: 'Anti Ragging' }]}
      />

      <div className="anti-ragging-page-container">

        {/* Notification Box (Red Theme) */}
        <section className="anti-ragging-notification-box red-theme">
          <div className="anti-ragging-notif-content flex-layout">
            <div className="alert-icon-wrapper"><RedShieldAlert /></div>
            <div className="alert-text-wrapper">
              <div className="alert-title">
                <strong>AICTE Notification</strong> <span className="date-badge">(Dated: 25.03.2009)</span>
              </div>
              <p>
                As per the notification of the All India Council for Technical Education (AICTE) regarding the prevention
                and prohibition of ragging in technical institutions, universities including deemed universities imparting
                technical education, ragging is <span className="text-red font-bold">strictly prohibited</span>. Any individual found guilty of ragging or abet-ting
                ragging shall be liable for punishment as per law.
              </p>
            </div>
          </div>
        </section>

        {/* Important Documents Section */}
        <section className="anti-ragging-section">
          <h2 className="anti-ragging-subheading"><BlueDocIcon /> Important Documents</h2>
          <div className="anti-ragging-doc-list">
            <div className="anti-ragging-doc-item">
              <div className="doc-info-wrapper">
                <div className="doc-icon-box"><RefinedPdfIcon /></div>
                <div className="doc-text">
                  <strong>Maharashtra State Act Against Ragging</strong>
                  <span className="doc-meta">PDF File • 1.2 MB</span>
                </div>
              </div>
              <div className="doc-actions">
                <a href="/pdf/admission/ACT_NO.-XXXIII_OF_1999-1.pdf" className="btn-outline" target="_blank" rel="noopener noreferrer">
                  <EyeIcon /> VIEW PDF
                </a>
                <a href="/pdf/admission/ACT_NO.-XXXIII_OF_1999-1.pdf" className="btn-solid" download>
                  <DownloadIcon /> DOWNLOAD PDF
                </a>
              </div>
            </div>
          </div>
          <p className="anti-ragging-footnote">* As per Maharashtra Act No. XXXIII of 1999 (Effective from 15 May 1999).</p>
        </section>

        {/* Maharashtra Prohibition Act Section (Card Grid) */}
        <section className="anti-ragging-section">
          <h2 className="anti-ragging-subheading">
            <BlueDocIcon /> Maharashtra Prohibition of Ragging Act, 1999
          </h2>
          <div className="act-cards-grid">
            <div className="act-card">
              <div className="act-card-header">
                <span className="act-number">01</span>
                <div className="act-icon">
                  <ActIconWrapper>
                    <circle cx="12" cy="12" r="10" />
                    <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
                  </ActIconWrapper>
                </div>
              </div>
              <p>Ragging within or outside any educational institution is <strong>strictly prohibited</strong>.</p>
            </div>
            <div className="act-card">
              <div className="act-card-header">
                <span className="act-number">02</span>
                <div className="act-icon">
                  <ActIconWrapper>
                    <path d="M12 3v18M3 7h18M6 7l-3 7s1 2 3 2 3-2 3-2l-3-7zM18 7l-3 7s1 2 3 2 3-2 3-2l-3-7zM9 21h6" />
                  </ActIconWrapper>
                </div>
              </div>
              <p>Any person involved directly or indirectly in ragging shall be punished with imprisonment up to two years and/or a fine up to ₹10,000.</p>
            </div>
            <div className="act-card">
              <div className="act-card-header">
                <span className="act-number">03</span>
                <div className="act-icon">
                  <ActIconWrapper>
                    <path d="M22 10v6M2 10l10-5 10 5-10 5zM6 12v5c3 3 9 3 12 0v-5" />
                  </ActIconWrapper>
                </div>
              </div>
              <p>A student convicted of ragging shall be dismissed from the institution for five years.</p>
            </div>
            <div className="act-card">
              <div className="act-card-header">
                <span className="act-number">04</span>
                <div className="act-icon">
                  <ActIconWrapper>
                    <path d="M3 11l18-5v12L3 14v-3zM11.6 16.8a3 3 0 1 1-5.8-1.6" />
                  </ActIconWrapper>
                </div>
              </div>
              <p>Complaints of ragging must be enquired into within seven days and forwarded to the police if found true.</p>
            </div>
            <div className="act-card">
              <div className="act-card-header">
                <span className="act-number">05</span>
                <div className="act-icon">
                  <ActIconWrapper>
                    <path d="M14 13l-9.5 9.5-3-3L11 10M14 13l4-4-4-4-4 4 4 4zM18 9l4-4-4-4-4 4 4 4zM5 21h4" />
                  </ActIconWrapper>
                </div>
              </div>
              <p>Failure of the Head of the Institution to act shall be treated as abetment of the offence.</p>
            </div>
          </div>
          <p className="anti-ragging-footnote">* As per Maharashtra Act No. XXXIII of 1999 (Effective from 15 May 1999).</p>
        </section>

        {/* Committees Section */}
        <section className="anti-ragging-section">
          <h2 className="anti-ragging-subheading">
            <SectionHeaderIcon style={{ flexShrink: 0 }} /> Ragging Prevention Committees
          </h2>

          <div className="anti-ragging-tables-grid">
            
            {/* Table 1 Card: Squad (ADDED STATE AND ONCLICK) */}
            <div className={`table-card ${openAccordion === 1 ? 'active' : ''}`}>
              <div 
                className="table-card-header flex-header" 
                onClick={() => toggleAccordion(1)}
              >
                <CardGroupIcon style={{ flexShrink: 0 }} />
                <h3 className="governing-title">Anti – Ragging Squad</h3>
              </div>
              <div className="table-container compact-container">
                <table className="responsive-table compact-table">
                  <thead>
                    <tr>
                      <th style={{ width: '40px' }}>SR.</th>
                      <th>MEMBER</th>
                      <th>DESIGNATION</th>
                    </tr>
                  </thead>
       <tbody>
                    <tr><td>1</td><td>Dr. Pravin Gundalwar</td><td><span className="badge-purple outline">Director</span></td></tr>
                    <tr><td>2</td><td>Mr. Shirshendu Maitra</td><td>Asst. Professor & HOD-ACA</td></tr>
                    <tr><td>3</td><td>Ms. Rohini Bagul</td><td>Asst. Professor</td></tr>
                    <tr><td>4</td><td>Mr. Shailesh Sharma</td><td>Office Superintendent</td></tr>
                    <tr><td>5</td><td>Mr. Priyanshu Chouhan</td><td>Student</td></tr>
                    <tr><td>6</td><td>Ms. Achala Pal</td><td>Student</td></tr>
                  </tbody>
                </table>
              </div>
            </div>

            {/* Table 2 Card: Committee (ADDED STATE AND ONCLICK) */}
            <div className={`table-card ${openAccordion === 2 ? 'active' : ''}`}>
              <div 
                className="table-card-header flex-header" 
                onClick={() => toggleAccordion(2)}
              >
                <CardGroupIcon style={{ flexShrink: 0 }} />
                <div>
                  <h3 className="governing-title">Anti – Ragging Committee</h3>
                  <p className="table-subtitle">Academic Year 2025-26</p>
                </div>
              </div>
              <div className="table-container compact-container">
                <table className="responsive-table compact-table">
                  <thead>
                    <tr>
                      <th style={{ width: '40px' }}>SR.</th>
                      <th>POSITION (AICTE)</th>
                      <th>MEMBER</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr><td>1</td><td>Head of the Institute <span className="badge-purple outline">Chairperson</span></td><td>Dr. Pravin Gundalwar</td></tr>
                    <tr><td>2</td><td>Police Admin</td><td>Mr. Narayan Patil</td></tr>
                    <tr><td>3</td><td>Local Media</td><td>Mr. Wasim Sheikh</td></tr>
                    <tr><td>4</td><td>NGO</td><td>Dr. Sangeeta Shirname</td></tr>
                    <tr><td>5</td><td>Faculty</td><td>Ms. Rupali Jadhav</td></tr>
                    <tr><td>6</td><td>Parent</td><td>Mr. Ramkrishna Sawant</td></tr>
                    <tr><td>7</td><td>Students</td><td>Mr. Vikas Shelar</td></tr>
                  </tbody>
                </table>
             
              </div>
            </div>
            
          </div>
        </section>

        {/* 3 Info Cards Section */}
        <section className="anti-ragging-section info-cards-section">

          {/* Blue Info Card */}
          <div className="info-card blue-card">

            <div className="info-card-header">
              <RefinedInfoIcon />
              <h4 className="unified-dark-heading">What is Ragging?</h4>
            </div>
            <ul className="info-check-list">
              <li><CircleTick color="#4f46e5" /> Verbal abuse and taunts</li>
              <li><CircleTick color="#4f46e5" /> Physical harassment</li>
              <li><CircleTick color="#4f46e5" /> Bullying and intimidation</li>
              <li><CircleTick color="#4f46e5" /> Online harassment</li>
              <li><CircleTick color="#4f46e5" /> Forced activities</li>
            </ul>
          </div>

          {/* Green Info Card */}
          <div className="info-card green-card">

            <div className="info-card-header">
              <RefinedPhoneIcon />
              <h4 className="unified-dark-heading">Report Ragging</h4>
            </div>
            <ul className="info-check-list">
              <li><CircleTick color="#4f46e5" /> Contact Anti-Ragging Committee</li>
              <li><CircleTick color="#4f46e5" /> Contact Faculty Mentor</li>
              <li><CircleTick color="#4f46e5" /> <strong>Email:</strong>  timscdrmumbai@thakureducation.org</li>
              <li><CircleTick color="#4f46e5" /> <strong>Helpline:</strong> 022 – 67308301 / 02</li>
              <li className="text-red"><CircleTick color="#ef4444" /> <strong>In case of emergency: 100 / 112</strong></li>
            </ul>
          </div>

          {/* Yellow Info Card */}
          <div className="info-card yellow-card">

            <div className="info-card-header">
              <RefinedShieldIcon />
              <h4 className="unified-dark-heading">Every Student Has the Right To</h4>
            </div>
            <ul className="info-check-list">
              <li><CircleTick color="#f59e0b" /> Safety on campus</li>
              <li><CircleTick color="#f59e0b" /> Respectful treatment</li>
              <li><CircleTick color="#f59e0b" /> Confidential complaint handling</li>
              <li><CircleTick color="#f59e0b" /> Protection from retaliation</li>
              <li><CircleTick color="#f59e0b" /> Support and guidance</li>
            </ul>
          </div>

        </section>

        {/* Zero Tolerance Banner */}
        <div className="anti-ragging-gradient-banner">
          <div className="banner-left">
            <BannerShieldIcon />
            <div className="banner-text">
              <h3>Zero Tolerance Towards Ragging</h3>
              <p>Ragging is a punishable offence. TIMSCDR maintains zero tolerance towards ragging in any form.</p>
            </div>
          </div>
          {/* <button className="banner-btn">LEARN MORE &rarr;</button> */}
        </div>

      </div>
      <Footer />
    </>
  );
};

export default AntiRagging;